import { Dialog, Paper, styled } from '@mui/material';
import { pxToRem } from '@themes';
var StyledDialog = styled(Dialog)(function (_ref) {
  var theme = _ref.theme,
      $maxWidth = _ref.$maxWidth;
  var styles = {
    // ToDo: remove if need adaptive
    '& .MuiDialog-container': {
      overflowX: 'auto'
    },
    '& .MuiPaper-modal-root': {
      // ToDo: modal adaptive
      // maxWidth: $maxWidth ? pxToRem($maxWidth) : undefined,
      // ToDo: remove if need adaptive
      width: $maxWidth ? pxToRem($maxWidth) : undefined,
      maxWidth: 'initial'
    }
  };
  return styles;
});
var StyledPaper = styled(Paper)(function (_ref2) {
  var theme = _ref2.theme;
  var styles = {
    borderRadius: theme.typography.pxToRem(12),
    width: "calc(100% - ".concat(theme.typography.pxToRem(64), ")") // ToDo: modal adaptive
    // [theme.breakpoints.down('tablet')]: {
    //   '&&': {
    //     margin:   `${theme.spacing(4)} ${theme.spacing(2)}`,
    //     maxWidth: `calc(100% - ${theme.typography.pxToRem(32)})`,
    //   },
    // },

  };
  return styles;
});
export { StyledDialog, StyledPaper };